import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Solution() {
  return <section className="w-full bg-ink py-20 text-white sm:py-28" data-id="element-169">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-170">
        <p className="mb-5 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-171">
          <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-172" />
          Es geht auch besser
        </p>
        <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl md:text-5xl" data-id="element-173">
          Was, wenn sie ums{' '}
          <span className="italic text-brand" data-id="element-174">Bauen betteln</span> würden —
          statt um den Bildschirm?
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/70" data-id="element-175">
          MakerLab gibt deinen Kindern 100+ praktische Roboter-Projekte, die sie
          wirklich machen wollen — gebaut aus einfachen Alltagsmaterialien,
          geführt durch leicht verständliche Schritt-für-Schritt-PDFs.
        </p>
        <div className="mt-10" data-id="element-176">
          <CtaButton data-id="element-177">Jetzt MakerLab sichern</CtaButton>
        </div>
      </div>
    </section>;
}